export default "__VITE_ASSET__BLTVTNIs__"